export class SiteMenuModel {
    id: number;
    parentId: number;
    name: string;
    displayName: string;
    displayOrder: number;
    navLink: string;
    applicationId: number;
    show: boolean;
    children: SiteMenuModel[];
    icon: string;
    classess: string;
    claimResource: string;
    claimOperator: string;
    parent: SiteMenuModel;
    resourceName: string;
    claimName: string;
    resourceId: number;
    claimId: number;
}



// WEBPACK FOOTER //
// ./src/app/client-core/dtos/site-menu.model.ts